import * as z from 'zod'

import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { BaseSchema_ContentsV1GetsafeDe } from '@flows/insurance/schemas'

const getErrorMap = (): z.ZodErrorMap => (issue, ctx) => {
  return (
    schemaUtils.bornOnErrorMap(issue, {
      min: 'sharedFlows_contentsNxt:steps.contents_birthday.errors.errorTooYoung',
      max: 'sharedFlows_contentsNxt:steps.contents_birthday.errors.errorTooOld',
    }) ?? { message: ctx.defaultError }
  )
}

const contents_birthday = (params: StepConfigParams) =>
  ({
    schema: z.object({
      born_on: BaseSchema_ContentsV1GetsafeDe.shape.born_on,
    }),
    errorMap: getErrorMap(),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_contentsNxt:steps.contents_birthday.title',
        },
      },
      {
        type: 'date',
        shouldTrackValues: true,
        name: 'born_on',
        disabledIfValueExists: true,
      },
    ],
    nextStep: 'contents_living_space',
    subFlow: params.subFlow,
  }) as const satisfies AnyStepConfiguration

export default contents_birthday
